<template>
  <v-list two-line subheader>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Title</v-list-item-title>
        <v-list-item-subtitle>{{ doc.title }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Description</v-list-item-title>
        <v-list-item-subtitle>{{ doc.description }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

     <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Slug</v-list-item-title>
        <v-list-item-subtitle>{{ doc.slug }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

     <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Icon</v-list-item-title>
        
        <v-list-item-subtitle> <v-icon>{{doc.icon}}</v-icon></v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

  </v-list>
</template>

<script>
// @ is an alias to /src

export default {
  name: "AdminGroupShow",
  data() {
    return {
      doc: {},
    };
  },
  created() {
    const ref = this.$parent.collection.doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    const ref = this.$parent.collection.doc(to.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
        next();
      } else {
        alert("No such document!");
      }
    });
  },
};
</script>

<style lang="scss">
  .tiles {
    display: flex;
    margin-top: 1rem;
    flex-wrap: wrap;
    .tile {
      width: 150px;
      height: 150px;
      background-size: cover;
      margin: 2px;
    }
  }
</style>
